import AdvertiserAuthModel from '@/models/AdvertiserAuthModel'
import InsertionOrderAuthModel from '@/models/InsertionOrderAuthModel'
import cloneDeep from 'lodash/cloneDeep'

// TODO 移動
class ModelTreeBuilder {
  static build(rawAuthChain, userType) {
    // 代理店の権限がinheritのとき
    if (rawAuthChain.permission === 'inherit') {
      let permission
      if (rawAuthChain.belong) {
        // 所属している広告主だった場合、accountTypeをみてpermissionを変える
        permission = ModelTreeBuilder.getPermissionFromUserType(userType)
      } else {
        // 所属している広告主出ない場合、権限を持っていないのでnone権限にする
        permission = 'none'
      }
      rawAuthChain.permission = permission
    }
    const advertiserAuthModel = new AdvertiserAuthModel(rawAuthChain)
    // IO作成
    if (rawAuthChain.insertionOrders !== undefined) {
      rawAuthChain.insertionOrders.forEach((ioAuth, index, ioAuths) => {
        // IoAuthモデルを作成
        const insertionOrderAuthModel = new InsertionOrderAuthModel(ioAuth)
        insertionOrderAuthModel.setAdvertiserAuthModel(advertiserAuthModel)
        // advertiserAuthModelに追加
        advertiserAuthModel.addInertionOrderAuth(insertionOrderAuthModel)
      })
    }
    return advertiserAuthModel
  }
  // TODO: 代理店の方と全く同じなので共通化
  // userTypeからpermissionを取得する
  static getPermissionFromUserType(userType) {
    switch (userType) {
      case 'sales':
        return 'view'
      case 'sales manager':
        return 'readonly'
      case 'operator':
        return 'view'
      case 'operator manager':
        return 'operator'
      case 'administrator':
        return 'admin'
    }
  }
}

const mutations = {
  INITIALIZE(state, { rawAuthChain, userType }) {
    if (rawAuthChain.permission === 'inherit') {
      // サーバに送信する際、これがtrueでadvertiserの編集が行われていない場合
      // サーバにはinheritを送信する
      state.isInheritInitialAdvertiserPermission = true
    }
    state.currentAuthChain = ModelTreeBuilder.build(rawAuthChain, userType)
    state.previousAuthChain = cloneDeep(state.currentAuthChain)
  },
  // 広告主が初めinheritだったときに立てる
  SET_ADVERTISER_INHERIT(state, { isInherit }) {
    state.isInheritAdvertiser = isInherit
  },
  // 現在編集中のuserTypeを保持
  SET_CURRENT_EDITING_USER_TYPE(state, { userType }) {
    state.currentEditingUserType = userType
  },
  SET_PARENT_PERMISSION(state, { permission }) {
    state.currentAuthChain.setPermission(permission)
  },
  // insertionOrderのpermissionをかえる
  SET_CHILD_PERMISSION(state, { id, permission }) {
    const insertionOrderAuth = state.currentAuthChain.insertionOrderAuths.find(
      io => {
        return io.id === id
      },
    )
    insertionOrderAuth.setPermission(permission)
  },
  // リセット時、previousの値をcurrentに入れる
  RESET(state) {
    state.currentAuthChain = cloneDeep(state.previousAuthChain)
  },
  // すべての子供についてinheritにする
  RESET_INHERIT_FLG(state) {
    state.currentAuthChain.insertionOrderAuths.forEach((io, index, ios) => {
      io.setPermission('inherit')
    })
  },
}

export default mutations
